import type { MenuItem, MenuItemLinkMetaData } from '../types';

// TODO: https://wix.atlassian.net/browse/MA-4435
export const normalizeMenuItemsLinkMetadata = (
  menuItems: MenuItem[],
): MenuItem[] => {
  return menuItems.map((_item) => {
    let item = _item;

    if (item.linkMetaData) {
      const allowedProperties = [
        'type',
        'target',
        'rel',
        'linkPopupId',
        'anchorDataId',
        'anchorCompId',
        'docInfo',
      ];

      const normalizedLinkMetaData = Object.fromEntries(
        Object.entries(item.linkMetaData).filter(([key, value]) => {
          return allowedProperties.includes(key) && value !== undefined;
        }),
      ) as MenuItemLinkMetaData;

      item = {
        ...item,
        linkMetaData: normalizedLinkMetaData,
      };
    }

    if (item.items?.length) {
      return {
        ...item,
        items: normalizeMenuItemsLinkMetadata(item.items),
      };
    }

    return item;
  });
};
